import classes from "../classes";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import expandable from "./higher-order/expandable";
import GameBoardHeaderDetails from "./game-board-header-details";
import React from "react";
import TournamentListItemHeader from "./tournament-list-item-header";
import { trackTournamentDetail } from "../analytics";

export default expandable(class GameBoardHeader extends React.PureComponent {

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    var { expanded, tournament, toggle } = this.props;

    toggle();
    if (!expanded) {
      trackTournamentDetail("Game Board", tournament, 1);
    }
  }

  render() {
    var { expanded, myTickets, races, tokenTypes, tournament } = this.props;
    var details;
    if (expanded) {
      details = (
        <CSSTransition
          classNames="tournament-table_row--details"
          timeout={{ enter: 250, exit: 250 }}>
          <GameBoardHeaderDetails key="game-board-header-details" races={races} tokenTypes={tokenTypes} tournament={tournament} />
        </CSSTransition>
      );
    }

    return (
      <div className={classes({
        "tournament-table": true,
        "tournament-table--cursor-is-default": true,
        "tournament-table--game-page-heading": true,
        "tournament-table--is-open": expanded
      })}>
        <TournamentListItemHeader
          isGameBoard
          myTicketsForTournament={myTickets}
          races={races}
          toggle={this.toggle}
          tokenTypes={tokenTypes}
          tournament={tournament} />

        <TransitionGroup>
          {details}
        </TransitionGroup>
      </div>
    );
  }
});
